import { render, staticRenderFns } from "./LeadContact.vue?vue&type=template&id=33654472&"
import script from "./LeadContact.vue?vue&type=script&lang=js&"
export * from "./LeadContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports